<template>
    <div>
        <div class="form filtered-table-filters" v-if="enableFilters && header.length">
            <div v-for="(header, index) in header" :key="index">
                <label v-if="columnsFilterable[index]" class="field select">
                    <span class="field-label">Filter by {{ header }}</span>
                    <select class="select" v-model="columnsActiveFilter[index]">
                        <option value="">All</option>
                        <option v-for="option in columnsOptions[index]" :value="option">{{ option | truncate() }}</option>
                    </select>
                </label>
            </div>
        </div>
        <table class="display-table">
            <caption v-if="caption">{{ caption }}</caption>
            <thead v-if="header.length">
                <tr>
                    <th scope="col" v-for="(column, index) in header" v-html="column" :key="index"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in filteredAndPaginatedRows">
                    <td v-for="(cell, index) in row" :key="index">
                        <span v-if="header.length && header[index]" v-html="header[index]" class="table-row-header"></span>
                        <div v-html="cell"></div>
                    </td>
                </tr>
                <tr v-if="!filteredAndPaginatedRows.length">
                    <td v-bind:colspan="totalColumns">No results. <button class="btn-clear-filters"
                            v-on:click="clearFilters">Clear Filters &times;</button></td>
                </tr>
            </tbody>
        </table>
        <div></div>
        <div v-if="totalPages > 1" class="filtered-table-pagination">
            <button type="button" class="btn sm rad btn01" v-on:click="prevPage"
                v-bind:disabled="currentPage === 1">Previous</button>
            <button type="button" class="btn sm rad btn01" v-on:click="nextPage"
                v-bind:disabled="currentPage === totalPages">Next</button>
            <div>{{ currentPage }} of {{ totalPages }}</div>
        </div>
    </div>
</template>
  
<script>
export default {
    props: {
        namespace: String
    },
    data() {
        return {
            caption: '',
            header: [],
            rows: [],
            totalColumns: 0,
            enableFilters: false,
            columnsFilterable: [],
            columnsActiveFilter: [],
            columnsOptions: [],
            currentPage: 1,
            pageSize: 12,
        };
    },
    computed: {
        filteredRows() {
            if (!this.enableFilters) {
                return this.rows;
            }

            return this.rows.filter((row) => {
                return row.every((column, index) => {
                    if (!this.columnsFilterable[index]) {
                        return true;
                    } else if (this.columnsActiveFilter[index] === '') {
                        return true;
                    } else if (column === this.columnsActiveFilter[index]) {
                        return true;
                    }
                    return false;
                });
            });
        },
        filteredAndPaginatedRows() {
            const start = (this.currentPage - 1) * this.pageSize;
            return this.filteredRows.slice(start, start + this.pageSize);
        },
        totalPages() {
            return Math.ceil(this.filteredRows.length / this.pageSize);
        }
    },
    mounted() {
        let tableData = document.getElementById(`${this.namespace}table_data`);

        tableData = JSON.parse(tableData.innerHTML);

        this.$set(this, "caption", tableData.caption);
        this.$set(this, "enableFilters", tableData.enableFilters);

        if (tableData.header && tableData.header.length) {
            this.$set(this, "header", tableData.header);
            this.$set(this, "rows", tableData.rows);
        } else if (this.enableFilters && tableData.rows.length > 1) {
            this.$set(this, "header", tableData.rows[0]);
            this.$set(this, "rows", tableData.rows.slice(1));
        } else {
            this.$set(this, "rows", tableData.rows);
        }

        if (this.rows.length >= 1) {
            this.$set(this, "totalColumns", tableData.rows[0].length);
        } else {
            return;
        }

        let filterKeys = [];

        if (this.enableFilters && tableData.filters.length) {
            filterKeys = tableData.filters;
        } else if (this.enableFilters && this.rows.length > 1) {
            filterKeys = this.header;
        }

        if (filterKeys.length) {
            for (let index = 0; index < this.totalColumns; index++) {
                this.$set(this.columnsFilterable, index, false);
                this.$set(this.columnsActiveFilter, index, '');
                this.$set(this.columnsOptions, index, []);
            }

            filterKeys.forEach(key => {
                let columnIndex = this.getColumnIndex(key);
                let columnOptions = this.getOptionsForColumn(columnIndex);
                this.$set(this.columnsFilterable, columnIndex, true);
                this.$set(this.columnsOptions, columnIndex, columnOptions);
            });
        }
    },
    methods: {
        getColumnIndex(key) {
            return this.header.indexOf(key);
        },
        getOptionsForColumn(index) {
            return [
                ...new Set(this.rows.map(row => row[index]))
            ]
                .sort()
                .filter(item => item);
        },
        nextPage() {
            if (this.currentPage < this.filteredRows.length / this.pageSize) {
                this.currentPage++;
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
        clearFilters() {
            this.columnsActiveFilter.forEach((_item, index) => {
                this.$set(this.columnsActiveFilter, index, '');
            });
        }
    },
    filters: {
        truncate: function (text, length = 50, suffix = '...') {
            if (text.length > length) {
                return text.substring(0, length) + suffix;
            } else {
                return text;
            }
        },
    }
};
</script>
<style>
.btn-clear-filters {
    display: inline-block;
    margin: 0 .5em;
    text-decoration: underline;
}

.btn-clear-filters:hover {
    text-decoration: none;
}
</style>